import { Vue, Component } from 'vue-property-decorator'
import GrossingTouchSidepanelWrapper from '@/modules/grossingModule/grossing-touch-view/components/grossing-touch-sidepanel-wrapper/grossing-touch-sidepanel-wrapper.vue'
import VtBubble from '@/components/common/VtBubble.vue'
import CommonCaseStatusBadge from '@/components/common/CommonCaseStatusBadge.vue'

@Component({
    components: {
        GrossingTouchSidepanelWrapper,
        CommonCaseStatusBadge,
        VtBubble
    }
})

export default class GrossingTouchCaseSidepanel extends Vue {
}
